<script>
export default {
    props: {
        id: String
    },
    render(h) {
        return h('div')
    },
    mounted() {
        let el = document.getElementById(this.id)
        if (!el) {
            return
        }
        let cloned = el.cloneNode(true)
        cloned.style.display = ''
        this.$el.appendChild(cloned)
    }
}
</script>